// extracted by mini-css-extract-plugin
module.exports = {"burgerCard":"burger-ingredients_burgerCard__3brUg","count":"burger-ingredients_count__1Q-Pv","titleContainer":"burger-ingredients_titleContainer__1MU7M"};